import { useContext } from 'react';
import { useIsNative } from '~/context/common/DeviceContext';
import GlobalContext, {
  useGetIsReturnUser
} from '~/context/home/GlobalContext';

function useDisplayRecommendedCarousels() {
  const isReturningUser = useGetIsReturnUser();
  const isNative = useIsNative();
  const { displayLowerFoldOnNative } = useContext(GlobalContext);

  return isNative
    ? isReturningUser && displayLowerFoldOnNative
    : isReturningUser;
}

export default useDisplayRecommendedCarousels;
